export default (formValues: any) => {
  const keys = Object.keys(formValues).filter((key: string) => key)

  return keys.reduce((allPassengerIds: string[], currentKey: string) => {
    const stringParts = currentKey.split('-')

    const currentPassengerId = isNaN(Number(stringParts[1]))
      ? stringParts[0]
      : `${stringParts[0]}-${stringParts[1]}`

    if (allPassengerIds.includes(currentPassengerId)) {
      return allPassengerIds
    }

    return [...allPassengerIds, currentPassengerId]
  }, [])
}
